import {Platform} from 'react-native';
import Config from 'react-native-config';
const isE2E = Config.E2E === 'true';

export default function testProperties(
  id: null | string,
  disableAccessible = false,
) {
  if (!isE2E) {
    return {};
  }

  const disableAccessibility = disableAccessible ? {accessible: false} : {};

  if (id && typeof id === 'string') {
    // On web, only return data-testid to avoid React DOM warnings
    if (Platform.OS === 'web') {
      return {'data-testid': id};
    }
    return {...disableAccessibility, testID: id};
  } else {
    if (Platform.OS === 'ios') {
      return {...disableAccessibility};
    }
  }

  return {};
}
